"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/languageController',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider"], function (require, exports, abortingRequest, ajaxSettingsProvider) {
    "use strict";

    var LanguageController = function () {
        function LanguageController() {
            _classCallCheck(this, LanguageController);
        }

        _createClass(LanguageController, [{
            key: "change",
            value: function change(data) {
                return abortingRequest.send('/api/language/Change', ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return LanguageController;
    }();

    return new LanguageController();
});
//# sourceMappingURL=languageController.js.map;
